module.exports = __webpack_public_path__ + "static/media/icon_specs-thickness.ca0b02b0.svg";